export default "__VITE_ASSET__BuW4oZ5P__"